
export default [{
    name: 'History',
    path: `history`,
    component: () => import('./components/Environment.vue'),
}];
